import { Paper, Title, SimpleGrid, Text, Stack, Center, Loader, ThemeIcon } from '@mantine/core';
import { IconLogin, IconLogout, IconShieldOff } from '@tabler/icons-react';
import { useKeycloakMetrics } from './usePrometheus';

export function KeycloakPanel() {
  const { data, isLoading } = useKeycloakMetrics();

  if (isLoading || !data) {
    return (
      <Paper shadow="xs" p="md" withBorder>
        <Title order={4} mb="md">Keycloak (letzte Stunde)</Title>
        <Center><Loader size="sm" /></Center>
      </Paper>
    );
  }

  return (
    <Paper shadow="xs" p="md" withBorder>
      <Title order={4} mb="md">Keycloak (letzte Stunde)</Title>
      <SimpleGrid cols={3}>
        <Center>
          <Stack align="center" gap={4}>
            <ThemeIcon size="lg" variant="light" color="green">
              <IconLogin size={20} />
            </ThemeIcon>
            <Text size="xl" fw={700}>{data.loginsPerHour}</Text>
            <Text size="xs" c="dimmed">Anmeldungen</Text>
          </Stack>
        </Center>
        <Center>
          <Stack align="center" gap={4}>
            <ThemeIcon size="lg" variant="light" color="blue">
              <IconLogout size={20} />
            </ThemeIcon>
            <Text size="xl" fw={700}>{data.logoutsPerHour}</Text>
            <Text size="xs" c="dimmed">Abmeldungen</Text>
          </Stack>
        </Center>
        <Center>
          <Stack align="center" gap={4}>
            <ThemeIcon size="lg" variant="light" color="red">
              <IconShieldOff size={20} />
            </ThemeIcon>
            <Text size="xl" fw={700}>{data.failedLoginsPerHour}</Text>
            <Text size="xs" c="dimmed">Fehlgeschlagen</Text>
          </Stack>
        </Center>
      </SimpleGrid>
    </Paper>
  );
}
